import { useCallback, useState } from 'react';

export interface ToastItem {
  id: string;
  message: string;
  type?: 'info' | 'success' | 'error' | 'warn';
  durationMs?: number;
  actionLabel?: string;
  onAction?: () => void;
}

export type ShowToastOptions = {
  durationMs?: number;
  actionLabel?: string;
  onAction?: () => void;
};

export function useToast() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const showToast = useCallback(
    (
      message: string,
      type: ToastItem['type'] = 'info',
      durationMsOrOptions: number | ShowToastOptions = 2800
    ) => {
      const opts: ShowToastOptions =
        typeof durationMsOrOptions === 'number'
          ? { durationMs: durationMsOrOptions }
          : durationMsOrOptions;
      const durationMs = opts.durationMs ?? 2800;
      const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
      setToasts((prev) => [
        ...prev,
        {
          id,
          message,
          type,
          durationMs,
          actionLabel: opts.actionLabel,
          onAction: opts.onAction,
        },
      ]);
      window.setTimeout(() => dismiss(id), durationMs);
      return id;
    },
    [dismiss]
  );

  return { toasts, showToast, dismiss };
}
